import React from "react";
import Contact from "../components/Contact";
import JsonData from "../data/data.json";
import { Routes, Route } from 'react-router-dom';
import ContactSuccess from '../components/ContactSuccess';

const ContactPage = () => {
  const contactData = JsonData.Contact;
  return (
    <Routes>
      <Route path="/" element={
        <div>
          <div style={{ marginBottom: "1.5rem" }} />
          <Contact data={contactData} />
        </div>
      } />
      <Route path="/contact-success" element={<ContactSuccess />} />
    </Routes>
  );
};

export default ContactPage;
